import { IconAlertTriangle, IconTrash } from '@tabler/icons-react';
import { Button } from '@xver/components/Atoms';
import { useTranslation } from 'react-i18next';

interface DangerZoneCardProps {
    isDestroying: boolean;
    onDestroy: () => void;
}

export default function DangerZoneCard({ isDestroying, onDestroy }: DangerZoneCardProps) {
    const { t } = useTranslation('bareMetal');

    return (
        <section
            aria-labelledby="baremetal-danger-zone"
            className="w-full rounded-md bg-surface-1 border-[0.5px] border-[#3f1d1d] light:border-red-300 overflow-hidden"
        >
            <div className="px-4 py-3 border-b-[0.5px] border-[#3f1d1d] light:border-red-300 flex flex-wrap items-center gap-2">
                <IconAlertTriangle size={18} color="#ef4444" aria-hidden />
                <h2 id="baremetal-danger-zone" className="text-base font-bold text-(--color-error)">
                    {t('detail.dangerZone.title')}
                </h2>
                <span className="text-sm text-fg/68">{t('detail.dangerZone.subtitle')}</span>
            </div>
            <div className="p-4 flex flex-row items-start justify-between gap-4">
                <div className="flex flex-col min-w-0 flex-1">
                    <span className="text-base text-fg">
                        {t('detail.dangerZone.destroyServer')}
                    </span>
                    <span className="text-sm text-fg/68">
                        {t('detail.dangerZone.destroyDescription')}
                    </span>
                </div>
                <Button
                    variant="danger"
                    leftIcon={<IconTrash size={16} />}
                    onClick={onDestroy}
                    disabled={isDestroying}
                >
                    {t('detail.dangerZone.destroyButton')}
                </Button>
            </div>
        </section>
    );
}
